import src from "IMAGE";
export default { src, width: 414, height: 122, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AC4+PD5CJjU0MDg4Njg4NiYmJCYmJB8fHQBBMDlRNiMzMi1BQUBPT05AQD5FRUQyMjDyPwojygNkOQAAAABJRU5ErkJggg=="};
